module.exports = __webpack_public_path__ + "media/flags/004-indonesia-01a29991.svg";